import { FormBase } from './form-base';

export class TextboxClass extends FormBase<string> {
    controlType = 'textbox';
    type: string;
    step: number;

    constructor(options: {} = {}) {
        super(options);
        this.type = options['type'] || '';
        this.step = options['step'] || 1;
        this.disabled = options['disabled'] || false;
    }
}